class StoreData {
    constructor() {
      this.storeDataArray = [];
      this.populateStoreData();
      this.setupSearch();
    }
  
    populateStoreData() {
      document.querySelectorAll('.store__locator__city__list').forEach(city => {
        this.storeDataArray.push({
          name: city.getAttribute('data-name'),
          handle: city.getAttribute('data-handle'),
          icon: city.getAttribute('data-icon'),
        });
  
        city.querySelectorAll('.store__locator__city__list__content input[type="hidden"]').forEach(input => {
          this.storeDataArray.push({
            name: input.getAttribute('data-name'),
            handle: input.getAttribute('data-handle'),
            icon : input.getAttribute('data-icon')
          });
        });
      });
  
      ////console.log("storeDataArray", this.storeDataArray);
    }
  
    setupSearch() {
      const searchInput = document.querySelector('#city__search');
      if (searchInput) {
        searchInput.addEventListener('keyup', (event) => {
          const query = event.target.value.toLowerCase();
          // Trigger search only if at least 3 characters are entered
          if (query.length >= 2) {
            this.search(query);
          } else {
            this.clearResults();
          }
        });
      }
    }
  
    search(query) {
      const results = this.storeDataArray.filter(item =>
        item.name.toLowerCase().includes(query)
      );
      
      this.displayResults(results);
    }
  
    displayResults(results) {
      const resultsContainer = document.querySelector('.search__list__show');
      if (resultsContainer) {
        if (results.length > 0) {
          resultsContainer.style.display = 'block'; // Show the container if there are results
          resultsContainer.innerHTML = ''; // Clear previous results
    
          results.forEach(result => {
            const li = document.createElement('li');
            li.innerHTML = `
              <a href="${result.handle}">
                <img src="${result.icon}" alt="">
                <p>${result.name}</p>
              </a>
            `;
            resultsContainer.appendChild(li);
          });
        } else {
          resultsContainer.style.display = 'none'; // Hide the container if there are no results
        }
      }
    }
    
  
    clearResults() {
      const resultsContainer = document.querySelector('.search__list__show');
      if (resultsContainer) {
        resultsContainer.style.display = 'none';
        resultsContainer.innerHTML = ''; // Clear previous results
      }
    }
  }
  
  // Create an instance to run the constructor
  new StoreData();

  class SwiperSlider {
    constructor() {
      this.initializeSwipers();
    }
  
    initializeSwipers() {
      // Select all elements with the class .mySwiperStoreImages
      const swiperElements = document.querySelectorAll('.mySwiperStoreImages');
      
      // Loop through each element and initialize a Swiper instance
      swiperElements.forEach((element, index) => {
        element.classList.add(`swiper-instance-${index}`); // Add a unique class to each element
        
        new Swiper(`.swiper-instance-${index}`, {
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable : true
          },
        });
      });
    }
  }
  
  // Instantiate the SwiperSlider class to apply the Swiper slider to each element
  new SwiperSlider();


  function redirectStorePage(){
   // alert('Testing')
   window.location.href = "https://www.nilkamalsleep.com/pages/store-locator";
  }


  function initMap(){

  //   // Location Marker
  //   const markers = [
  //     {
  //       locationName : 'Nilkamal Sleep - Jayanagar',
  //       lat : 13.307735241344231, 
  //       lng : 77.62873072823942,
  //       address : 'No 14, A-93, 22nd Cross Rd, Bairasandra Extension, Jaya Nagar 1st Block, Jayanagar 3rd Block, Jayanagar, Bengaluru, Karnataka 560011',
  //       storeImage : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Velvette_Upholstered_Bed_Blue_Lite_Dual_Comfort_Queen_-_2.jpg?v=1725966989',
  //       storeURL : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Mattress-Dimension-1_1_b81731ee-206a-4fb3-a89f-24d59f67b80a.jpg?v=1725529679',
  //     },
  //     {
  //       locationName : 'Nilkamal Sleep - HSR Layout',
  //       lat : 12.952591113195751, 
  //       lng : 77.64287898764174, 
  //       address : 'No 905, 1073, 1st Sector, HSR Layout, Bengaluru, Karnataka 560102',
  //       storeImage : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Velvette_Upholstered_Bed_Blue_Lite_Dual_Comfort_Queen_-_2.jpg?v=1725966989',
  //       storeURL : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Mattress-Dimension-1_1_b81731ee-206a-4fb3-a89f-24d59f67b80a.jpg?v=1725529679',
  //     },
  //     {
  //       locationName : 'Nilkamal Sleep - Banaswadi',
  //       lat : 13.051749830604537,  
  //       lng : 77.64115410796124, 
  //       address : 'No. 13/5AC/933, 1st Block Extension 5th A Cross, HRBR Layout Hennur, Outer Ring Rd, Banaswadi, Bengaluru, Karnataka 560043',
  //       storeImage : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Velvette_Upholstered_Bed_Blue_Lite_Dual_Comfort_Queen_-_2.jpg?v=1725966989',
  //       storeURL : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Mattress-Dimension-1_1_b81731ee-206a-4fb3-a89f-24d59f67b80a.jpg?v=1725529679',
  //     },
  //     {
  //       locationName : 'Nilkamal Sleep - Kadubeesanahalli',
  //       lat : 12.984527905409246,   
  //       lng : 77.75327128719366, 
  //       address : 'No 58, Ground Floor, Outer Ring Road, Shiva Kumbeshwara Nilaya, Kadubeesanahalli, Panathur Rd, near Ola Experience Center, Bengaluru, Karnataka 560103',
  //       storeImage : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Velvette_Upholstered_Bed_Blue_Lite_Dual_Comfort_Queen_-_2.jpg?v=1725966989',
  //       storeURL : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Mattress-Dimension-1_1_b81731ee-206a-4fb3-a89f-24d59f67b80a.jpg?v=1725529679',
  //     },
  //     {
  //       locationName : 'Nilkamal Sleep - Lasudia Mori',
  //       lat : 22.835536169060465,   
  //       lng : 75.90225758465324, 
  //       address : 'AB Rd, near Nexa Showroom, Khandelwal Compound, Lasudia Mori, Indore, Madhya Pradesh 453771',
  //       storeImage : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Velvette_Upholstered_Bed_Blue_Lite_Dual_Comfort_Queen_-_2.jpg?v=1725966989',
  //       storeURL : 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Mattress-Dimension-1_1_b81731ee-206a-4fb3-a89f-24d59f67b80a.jpg?v=1725529679',
  //     }
  // ]
   
  // Array to store dynamically created markers
const markers = [];

// Select all the hidden input elements with data attributes
const inputs = document.querySelectorAll('.data__markup');
const storeList = document.querySelectorAll('.storeLatLong')

// Loop through each input element and create an object for each one
inputs.forEach(input => {
  const marker = {
    locationName: input.getAttribute('data-name'),
    lat: parseFloat(input.getAttribute('data-lat')),  // Convert to float for lat
    lng: parseFloat(input.getAttribute('data-long')), // Convert to float for lng
    address: input.getAttribute('data-storeaddress'),
    storeImage: input.getAttribute('data-storeImage'),      // Assuming this is the store image URL
    storeURL: input.getAttribute('data-handle')       // Assuming this is the store URL
  };
  
  // Push the created object to the markers array
  markers.push(marker);
});

storeList.forEach(input => {
  const marker = {
    locationName: input.getAttribute('data-name'),
    lat: parseFloat(input.getAttribute('data-lat')),  // Convert to float for lat
    lng: parseFloat(input.getAttribute('data-long')), // Convert to float for lng
    address: input.getAttribute('data-storeaddress'),
    storeImage: input.getAttribute('data-storeImage'),      // Assuming this is the store image URL
    storeURL: input.getAttribute('data-handle')       // Assuming this is the store URL
  };
  
  // Push the created object to the markers array
  markers.push(marker);
});



  const fehMarker = 'https://cdn.shopify.com/s/files/1/0248/7766/2271/files/Button_-_Travancore_-_Travancore_transparent_png.png?v=1725981336';

  const mapInitElement = document.querySelector('.initMapLatLong');
  
  // Extract the latitude and longitude from data attributes
  const latitude = parseFloat(mapInitElement.getAttribute('data-mapInitLat')); 
  const longitude = parseFloat(mapInitElement.getAttribute('data-mapInitLong')); 
    const centerMap = {lat: latitude, lng: longitude};
    const bounds = new google.maps.LatLngBounds();
    const mapOptions = {
      center : centerMap,
      zoom : 4,
      disableDefaultUI: true
    };
    const map = new google.maps.Map(document.querySelector('.store__locator__map__container'), mapOptions);

    const infoWindow = new google.maps.InfoWindow({
      minWidth : 350,
      maxWidth : 350
    })

    for(let i = 0; i < markers.length; i++ ){
      const marker = new google.maps.Marker({
        position : {lat: markers[i]['lat'] , lng : markers[i]['lng']},
        map : map,
        icon : fehMarker
      })

      function createInfoWindow(){
        const infoWindowContent = `<div class="feh-content">
        <div class="feh-image">
        <img src="${markers[i]['storeImage']}" />
        </div>
        <div class="feh-actual-content">
        <h3>${markers[i]['locationName']}</h3>
        <p>${markers[i]['address']}</p>
        <a href="${markers[i]['storeURL']}">Get Direction</a>
        </div>
        </div>`;

        google.maps.event.addListener(marker, 'click', function(){
          infoWindow.setContent(infoWindowContent);
          infoWindow.open(map , marker);
        })
      }
      createInfoWindow();

      infoWindow.addListener('closeclick', function() {
        map.fitBounds(bounds)
      });

      bounds.extend(new google.maps.LatLng(markers[i]['lat'], markers[i]['lng']))
      map.fitBounds(bounds);
    }
  }

  // const bookVisitButtons = document.querySelectorAll('.single__store__cta__book');
  // const storeNameInput = document.querySelector('#store-name');
  // const popup = document.getElementById('popupForm');
  // const closeButton = document.querySelector('.close');
  // bookVisitButtons.forEach(elem => {
  //   elem.addEventListener('click', function() {
  //     const clickelem = this.dataset.storeName;
  //     //console.log(clickelem);  // This will log the clicked element
  //     storeNameInput.value = clickelem;
  //     popup.style.display = 'block';
  //     document.querySelector('body').classList.add('myStoreStopScroll')
  //   });
  // });
  
  // // Close the popup when the user clicks on the "x" button
  // closeButton.addEventListener('click', function() {
  //   popup.style.display = 'none';
  //   document.querySelector('body').classList.remove('myStoreStopScroll');
  // });

  // // Close the popup if the user clicks anywhere outside of the popup content
  // window.addEventListener('click', function(event) {
  //   if (event.target == popup) {
  //     popup.style.display = 'none';
  //     document.querySelector('body').classList.remove('myStoreStopScroll');
  //   }
  // });

 
 


  
 